import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chat-layout-closed",
  "use": "chat-layout-closed-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"chat-layout-closed\"><g fill=\"none\" fill-rule=\"evenodd\" stroke-width=\"1.5\"><rect width=\"22.5\" height=\"6.5\" x=\".75\" y=\".75\" rx=\"1\" /><rect width=\"22.5\" height=\"12.5\" x=\".75\" y=\"10.75\" rx=\"1\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol